type EnumLiteralsOf<T extends unknown> = T[keyof T];
export const CostingStatus = Object.freeze({
  CHECKING: 1 as const,
  CHECKED: 2 as const,
  REJECT: 3 as const,
  EDIT: 4 as const,
});

export type CostingStatus = EnumLiteralsOf<typeof CostingStatus>;
